import { module } from 'modujs'
import Plyr from 'plyr'

export default class extends module {
  init() {
    this.playerElt = this.el.querySelector('.c-player_elt')
    this.player = new Plyr(this.playerElt, { youtube: { noCookie: true } })

    this.onClickOpenPopin = this.onClickOpenPopin.bind(this)
    this.onClickClosePopin = this.onClickClosePopin.bind(this)

    this.openPopinEl = document.querySelector('.openPopin')
    this.closePopinEl = document.querySelector('.c-player_close')

    this.openPopinEl?.addEventListener('click', this.onClickOpenPopin)
    this.closePopinEl?.addEventListener('click', this.onClickClosePopin)

    this.io = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting && this.player?.playing)
        this.player?.pause()
    })

    this.io.observe(this.el)
  }

  onClickOpenPopin(e) {
    e.preventDefault()
    this.open()
  }

  onClickClosePopin(e) {
    e.preventDefault()
    this.close()
  }

  close() {
    this.el.classList.remove('-visible')
    this.call('start', 'Scroll')

    this.player?.pause()
  }

  open() {
    this.el.classList.add('-visible')
    this.call('stop', 'Scroll')

    this.player?.play()
  }

  destroy() {
    this.io.disconnect()
    this.openPopinEl?.removeEventListener('click', this.onClickOpenPopin)
    this.closePopinEl?.removeEventListener('click', this.onClickClosePopin)
    this.player?.destroy()
  }
}
